import { useQuery } from '@tanstack/react-query';

import { useMetaApiInstance } from '../api';
import { HOST_QUERY_KEY } from '../constants';
import useServiceAppState from './useServiceAppState';

import type { MegaMenuCategory } from '../constants';

interface UseAllRegionMegaMenuQueryParams {
  /** false면 조회하지 않습니다. 필요한 시점에만 fetch를 유발할 때 사용합니다. */
  enabled?: boolean;
}

/**
 * 현재 선택된 리전과 무관하게 region='all'로 전 리전 통합 메가메뉴를 조회하는 훅입니다.
 * @description
 * - viewPoint 등 별도 가공 없이 원본 카테고리/서비스를 그대로 반환하는 중립 소스입니다(소비처에서 필요한 가공 수행).
 * - 전용 queryKey를 사용하므로 useMegaMenuQuery(현재 리전 캐시)와 분리되어 서로 재호출을 유발하지 않습니다.
 * - 필수 데이터가 아니므로 Suspense가 아닌 useQuery로 조회합니다(소비처에서 data 기본값/로딩 처리).
 * - TODO: 향후 useMegaMenuQuery를 region 파라미터('all' 포함) 기반으로 일반화하여 통합될 수 있습니다.
 */
const useAllRegionMegaMenuQuery = ({ enabled = true }: UseAllRegionMegaMenuQueryParams = {}) => {
  const {
    state: { language },
  } = useServiceAppState();
  const { fetchMegaMenu } = useMetaApiInstance();

  return useQuery<MegaMenuCategory[]>({
    queryKey: [HOST_QUERY_KEY.GET_ALL_REGION_MEGA_MENU, { language }],
    queryFn: () => fetchMegaMenu({ region: 'all' }),
    staleTime: Infinity,
    enabled,
  });
};

export default useAllRegionMegaMenuQuery;
